
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 80 40"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"Icons/Sonstiges/Haeuser-Privat-0","fill":"transparent","fill-rule":"evenodd","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2"}},[_c('path',{attrs:{"id":"Haus1","d":"M3 23.4v8.889c0 .392.29.711.647.711h9.706c.358 0 .647-.319.647-.711V23.4L8.5 17 3 23.4z"}}),_c('path',{attrs:{"id":"Haus2","d":"M20 21.6v10.556c0 .466.342.844.765.844h11.47c.423 0 .765-.378.765-.844V21.6L26.5 14 20 21.6z"}}),_c('path',{attrs:{"id":"Haus3","d":"M39 19.2v12.778c0 .564.394 1.022.882 1.022h13.236c.488 0 .882-.458.882-1.022V19.2L46.5 10 39 19.2z"}}),_c('path',{attrs:{"id":"Haus4","d":"M60 18v13.889c0 .613.447 1.111 1 1.111h15c.553 0 1-.498 1-1.111V18L68.5 8 60 18z"}})])])
          )
        }
      }
    